import { render, staticRenderFns } from "./PedidosPrincipal.vue?vue&type=template&id=096588f8&"
import script from "./PedidosPrincipal.vue?vue&type=script&lang=js&"
export * from "./PedidosPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports